/**
 * An idempotency key for a state-changing request (TZ section 17).
 *
 * The screen owns it, not the request: a form keeps one key for as long as it
 * describes the same intent, so pressing the button twice, or retrying after a
 * dropped connection, is recognised as one request rather than queued twice.
 */
export function idempotencyKey(prefix: string): string {
  return `${prefix}.${crypto.randomUUID()}`;
}
